/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { WithVersion } from '@gh/common-shared-data';

export type CheckUsageDto = WithVersion<{
  deleted: boolean;
}>;
export type CheckUsage = CheckUsageDto;

export const CHECK_USAGE_NOT_USED: CheckUsage = { version: -1, deleted: true };
